import 'es6-promise/auto'
import 'core-js'

import Vue from 'vue'

import {get} from 'lodash'
import './views/components'

import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import '@/style/app.scss';
Vue.use(Buefy, {
    defaultLocale: 'ru-RU'
});

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.mixin({
    computed: {
        $_get () {
            return get
        },
    }
})